import LoadingSpinner from "../loading-spinner";
import { Skeleton } from "../ui/skeleton";

export default function InboxSidebarSkeleton() {
    return (
        <div className="flex flex-col h-full">
            <div className="flex items-center justify-between py-2 pl-2 pr-3 border-b border-neutral-200">
                <div className="font-medium  flex items-center">
                    <span className="size-9 grid place-items-center">
                        <LoadingSpinner className="size-4" />
                    </span>
                    <div className="ml-2 text-zinc-600">
                        <Skeleton className="h-3 w-[150px]" />
                    </div>
                </div>
            </div>
        </div>
    );
}
